module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "BHD"
  }, [_vm._v("FILLING A PIPING BAG")]), _vm._v(" "), _c('h5', {
    staticClass: "CHD"
  }, [_vm._v("SINGLE COLOUR")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_vm._v("For a single colour, use a tall glass or vase to support your piping bag then scoop the buttercream into it.")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F38.jpg"
    }
  })]), _vm._v(" "), _c('h5', {
    staticClass: "CHD",
    attrs: {
      "id": "T1"
    }
  }, [_vm._v("TWO-TONE EFFECT")]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-left",
    attrs: {
      "id": "F1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F39.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('b', [_vm._v("1")]), _vm._v(". Prepare your tinted buttercream in two separate piping bags and cut a medium hole at the tip of each. The ‘stripe’ colour should be piped into a third bag, with the nozzle attached, where the narrow end of the nozzle is ("), _c('a', {
    attrs: {
      "href": "#/Chapter16#F1"
    }
  }, [_vm._v("A")]), _vm._v(").")])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-left",
    attrs: {
      "id": "F2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F40.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('b', [_vm._v("2")]), _vm._v(". Pipe the dominant colour on top of the stripe colour to fill the bag ("), _c('a', {
    attrs: {
      "href": "#/Chapter16#F2"
    }
  }, [_vm._v("B")]), _vm._v(").")])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-left",
    attrs: {
      "id": "F3"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F41.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('b', [_vm._v("3")]), _vm._v(". Squeeze the piping bag until you get the right effect ("), _c('a', {
    attrs: {
      "href": "#/Chapter16#F3"
    }
  }, [_vm._v("C")]), _vm._v("). To adjust the thickness of the stripe colour, just turn the nozzle clockwise or counter-clockwise.")])]), _vm._v(" "), _c('div', {
    staticClass: "tip-box"
  }, [_c('h4', {
    staticClass: "TIP-AHD"
  }, [_vm._v("TIP")]), _vm._v(" "), _c('p', {
    staticClass: "TIP1"
  }, [_vm._v("Do not over-fill your piping bag – you need to be able to get a good grip so that you can control the squeeze as you pipe, and also you don't want your hands to get tired.")])]), _vm._v(" "), _c('h5', {
    staticClass: "CHD",
    attrs: {
      "id": "B1"
    }
  }, [_vm._v("BLENDED TWO-TONE EFFECT")]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-left",
    attrs: {
      "id": "F4"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F42.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('b', [_vm._v("1")]), _vm._v(". Repeat the same process as for the two-tone effect but randomly pinch the part of the bag where the stripe colour mixes with the dominant colour to create a blended effect.")])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-left",
    attrs: {
      "id": "F5"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F43.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('b', [_vm._v("2")]), _vm._v(". Squeeze the piping bag until you're happy with the effect.")])]), _vm._v(" "), _c('h5', {
    staticClass: "CHD"
  }, [_vm._v("THREE-TONE EFFECT")]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-left",
    attrs: {
      "id": "F6"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F44.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('b', [_vm._v("1")]), _vm._v(". Fill three separate piping bags with your chosen shades of buttercream ("), _c('a', {
    attrs: {
      "href": "#/Chapter16#F6"
    }
  }, [_vm._v("A")]), _vm._v("), and prepare a large piece of cling film (plastic wrap).")])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-left",
    attrs: {
      "id": "F7"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F45.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('b', [_vm._v("2")]), _vm._v(". Cut a medium-sized hole at the tip of each of the piping bags and squeeze them onto the sheet of cling film in whatever order you like ("), _c('a', {
    attrs: {
      "href": "#/Chapter16#F7"
    }
  }, [_vm._v("B")]), _vm._v(").")])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-left",
    attrs: {
      "id": "F8"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F46.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('b', [_vm._v("3")]), _vm._v(". Roll the cling film up and make it like a sausage. Twist both ends and tie one end tightly ("), _c('a', {
    attrs: {
      "href": "#/Chapter16#F8"
    }
  }, [_vm._v("C")]), _vm._v(").")])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-left",
    attrs: {
      "id": "F9"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F47.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('b', [_vm._v("4")]), _vm._v(". Prepare your piping bag with a coupler. Thread the twisted part of the cling film to the coupler, pull it through the opening and cut the end off, then attach the ring with the nozzle to the base of the coupler.")])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-left",
    attrs: {
      "id": "F10"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F48.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('b', [_vm._v("5")]), _vm._v(". Squeeze the piping bag until you get the right effect. You may also try more than three colours using the same technique.")])]), _vm._v(" "), _c('div', {
    staticClass: "tip-box"
  }, [_c('h4', {
    staticClass: "TIP-AHD"
  }, [_vm._v("TIP")]), _vm._v(" "), _c('p', {
    staticClass: "TIP1"
  }, [_vm._v("If you need a lot of buttercream, it's a good idea to prepare two full piping bags in advance.")])]), _vm._v(" "), _c('h5', {
    staticClass: "CHD",
    attrs: {
      "id": "M1"
    }
  }, [_vm._v("MARBLED EFFECT")]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-left",
    attrs: {
      "id": "F11"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F49.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('b', [_vm._v("1")]), _vm._v(". Prepare your chosen colours and place them in the same bowl ("), _c('a', {
    attrs: {
      "href": "#/Chapter16#F11"
    }
  }, [_vm._v("A")]), _vm._v(").")])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-left",
    attrs: {
      "id": "F12"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F50.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image-left",
    attrs: {
      "id": "F13"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F51.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('b', [_vm._v("2")]), _vm._v(". Blend the colours lightly ("), _c('a', {
    attrs: {
      "href": "#/Chapter16#F12"
    }
  }, [_vm._v("B")]), _vm._v("). Scoop the buttercream into your piping bag ("), _c('a', {
    attrs: {
      "href": "#/Chapter16#F13"
    }
  }, [_vm._v("C")]), _vm._v(").")])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-left",
    attrs: {
      "id": "F14"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F52.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('b', [_vm._v("3")]), _vm._v(". Squeeze the piping bag until you get the right effect ("), _c('a', {
    attrs: {
      "href": "#/Chapter16#F14"
    }
  }, [_vm._v("D")]), _vm._v(").")])]), _vm._v(" "), _c('div', {
    staticClass: "tip-box"
  }, [_c('h4', {
    staticClass: "TIP-AHD"
  }, [_vm._v("TIP")]), _vm._v(" "), _c('p', {
    staticClass: "TIP1"
  }, [_vm._v("Do not over-blend the buttercream as it will turn into one colour. You could use more than two colours. Untinted buttercream is usually a good third choice as it balances the other colours.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5775f4e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter16.vue
// module id = 87
// module chunks = 0